/**
 * Lightweight A/B testing helper.
 * - Persists a variant assignment per experiment in localStorage.
 * - Sends impression + conversion events to /api/analytics/track-ab-event.
 * - Currently used by the homepage hero carousel (experiment: "homepage_hero")
 *   so engagement on the new "AI Employee" variant can be compared against a
 *   future legacy variant when re-introduced.
 */
import api from '@/services/api';

const STORAGE_PREFIX = 'hx_ab_';

export function getVariant(experiment, variants = ['v2-ai-employee']) {
  if (!experiment || !variants || variants.length === 0) return null;
  const key = STORAGE_PREFIX + experiment;
  try {
    const existing = localStorage.getItem(key);
    if (existing && variants.includes(existing)) return existing;
  } catch (e) { console.warn('abTest: localStorage read failed', e); }
  const choice = variants[Math.floor(Math.random() * variants.length)];
  try { localStorage.setItem(key, choice); } catch (e) { console.warn('abTest: localStorage write failed', e); }
  return choice;
}

export function trackAbEvent(experiment, variant, event, meta = {}) {
  if (!experiment || !variant || !event) return;
  try {
    api.post('/analytics/track-ab-event', { experiment, variant, event, meta }).catch((e) => console.warn('abTest: track post failed', e));
  } catch (e) { console.warn('abTest: track threw', e); }
}
